import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { BASE_LANGUAGE } from '../constants'
import en from './en'
// import fi from './fi'

Vue.use(VueI18n)

export const i18n = new VueI18n({
  locale: BASE_LANGUAGE,
  fallbackLocale: BASE_LANGUAGE,
  messages: {
    en
    // fi
  }
})

export const dateOptions = (locale) => {
  switch (locale) {
    case 'en':
      return { year: 'numeric', month: 'short', day: '2-digit' }
    case 'fi':
      return { year: 'numeric', month: '2-digit', day: '2-digit' }
    default:
      return { year: 'numeric', month: '2-digit', day: '2-digit' }
  }
}
